import React, { Component, ReactNode } from 'react';
import { Input } from 'antd';
import Icon from '@ant-design/icons';
import { ReactComponent as SearchSvg } from '../../assets/sightx-icons/svg/sx-search-lg.svg';
import { UpdateTableQueryPayload } from '../../slices/users/list';

interface Props {
  searchQuery: string;
  onSearch:(payload: UpdateTableQueryPayload) => void;
  placeholder?: string;
  trim?: 'leading' | 'trailing' | 'leadingAndTrailing' |'none';
}

interface State {
  searchedValue: string;
}

export class TextSearch extends Component<Props, State> {
  static defaultProps: Pick<Props, 'trim'> = {
    trim: 'leadingAndTrailing'
  };
  constructor(props:Props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state = {
      searchedValue: ''
    };
  }

  componentDidMount(): void {
    this.setState({ searchedValue: this.props.searchQuery });
  }

  componentDidUpdate(): void {
    const { searchQuery } = this.props;
    const searchQueryTrimmed = this.getTrimmedValue(searchQuery);
    if (searchQueryTrimmed !== this.state.searchedValue) {
      this.setState({ searchedValue: searchQueryTrimmed });
    }
  }

  private getTrimmedValue(value: string) {
    const { trim } = this.props;

    let returnValue = value;
    switch (trim) {
    case 'leading':
      returnValue = value.trimStart();
      break;
    case 'trailing':
      returnValue = value.trimEnd();
      break;
    case 'leadingAndTrailing':
      returnValue = value.trim();
      break;
    case 'none':
      break;
    }

    return returnValue;
  }

  onChange(e:React.ChangeEvent<HTMLInputElement>):void {
    const searchedValue = e.target.value;
    const searchValue = this.getTrimmedValue(searchedValue);

    this.setState({
      searchedValue: searchValue
    }, () => {
      this.props.onSearch(this.state.searchedValue);
    });
  }

  render():ReactNode {
    const { placeholder = 'Search' } = this.props;
    const { searchedValue } = this.state;
    return (
      <Input
        onChange={this.onChange}
        placeholder={placeholder}
        value={searchedValue}
        suffix={<Icon component={SearchSvg} />}
      />
    );
  }
}
